import { render, staticRenderFns } from "./classAlbum.vue?vue&type=template&id=2f524bda&scoped=true&"
import script from "./classAlbum.vue?vue&type=script&lang=js&"
export * from "./classAlbum.vue?vue&type=script&lang=js&"
import style0 from "./classAlbum.vue?vue&type=style&index=0&id=2f524bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f524bda",
  null
  
)

export default component.exports